import { CSSProperties } from 'react';

export const styles: Record<string, CSSProperties> = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f3f4f6',
    paddingBottom: '80px',
    position: 'relative'
  },
  successMessage: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: '#10b981',
    color: 'white',
    padding: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    zIndex: 2000,
    animation: 'slideDown 0.3s ease-out',
    fontSize: '20px',
    fontWeight: '700',
    boxShadow: '0 4px 12px rgba(16, 185, 129, 0.4)'
  },
  header: {
    backgroundColor: '#1f2937',
    color: 'white',
    padding: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  headerLeft: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    margin: 0
  },
  userName: {
    fontSize: '14px',
    opacity: 0.9
  },
  statusBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '6px 12px',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: 'bold'
  },
  statusDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%'
  },
  warningBar: {
    backgroundColor: '#fef2f2',
    color: '#991b1b',
    padding: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    fontWeight: 'bold'
  },
  accuracyWarning: {
    backgroundColor: '#fef3c7',
    color: '#92400e',
    padding: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    fontSize: '14px'
  },
  shopStatusBar: {
    backgroundColor: '#dbeafe',
    color: '#1e40af',
    padding: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    fontWeight: '500'
  },
  jobSelector: {
    backgroundColor: 'white',
    margin: '16px',
    padding: '16px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
  },
  jobSelectorContent: {
    flex: 1
  },
  jobSelectorLabel: {
    fontSize: '11px',
    fontWeight: '600',
    color: '#6b7280',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '8px'
  },
  jobName: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#1f2937',
    marginBottom: '4px'
  },
  jobAddress: {
    fontSize: '14px',
    color: '#6b7280',
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  },
  locationIcon: {
    fontSize: '14px'
  },
  jobDistance: {
    fontSize: '13px',
    color: '#9ca3af'
  },
  atLocationBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 8px',
    backgroundColor: '#d1fae5',
    color: '#065f46',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: '500',
    marginTop: '8px'
  },
  jobPlaceholder: {
    color: '#9ca3af',
    fontSize: '16px'
  },
  notAtJobWarning: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  jobSelectorArrow: {
    fontSize: '18px',
    color: '#6b7280'
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'flex-end',
    zIndex: 1000
  },
  modalContent: {
    backgroundColor: 'white',
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
    padding: '24px',
    width: '100%',
    maxHeight: '80vh',
    overflow: 'auto'
  },
  modalContentSmall: {
    backgroundColor: 'white',
    borderRadius: '16px',
    padding: '24px',
    margin: '20px',
    maxWidth: '400px',
    width: '100%',
    textAlign: 'center'
  },
  locationWarning: {
    backgroundColor: '#fef3c7',
    color: '#92400e',
    padding: '12px',
    borderRadius: '8px',
    marginBottom: '16px',
    textAlign: 'center'
  },
  notAtJobBanner: {
    backgroundColor: '#fef2f2',
    color: '#991b1b',
    padding: '12px',
    borderRadius: '8px',
    marginBottom: '16px',
    textAlign: 'center',
    fontWeight: '500'
  },
  currentJobDisplay: {
    marginBottom: '8px'
  },
  jobsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  jobItem: {
    padding: '16px',
    backgroundColor: '#f9fafb',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.2s'
  },
  selectedJob: {
    backgroundColor: '#e0f2fe',
    border: '2px solid #0284c7'
  },
  withinGeofence: {
    backgroundColor: '#d1fae5',
    border: '2px solid #10b981'
  },
  jobItemHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '4px'
  },
  jobItemName: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#1f2937'
  },
  jobItemDistance: {
    fontSize: '13px',
    color: '#6b7280'
  },
  jobItemDetails: {
    fontSize: '13px',
    color: '#6b7280',
    marginBottom: '4px'
  },
  jobItemAddress: {
    fontSize: '13px',
    color: '#9ca3af'
  },
  atLocationBadgeSmall: {
    marginLeft: '8px',
    padding: '2px 6px',
    backgroundColor: '#10b981',
    color: 'white',
    borderRadius: '4px',
    fontSize: '11px',
    fontWeight: '500'
  },
  noNearbyJobs: {
    padding: '32px',
    textAlign: 'center',
    color: '#6b7280'
  },
  modalClose: {
    width: '100%',
    padding: '14px',
    backgroundColor: '#f3f4f6',
    border: 'none',
    borderRadius: '8px',
    color: '#6b7280',
    fontWeight: '600',
    fontSize: '16px',
    cursor: 'pointer',
    marginTop: '16px'
  },
  buttonContainer: {
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  clockButton: {
    width: '100%',
    padding: '24px',
    borderRadius: '16px',
    border: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
  },
  clockInButton: {
    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    color: 'white'
  },
  clockOutButton: {
    background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
    color: 'white'
  },
  convertButton: {
    background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
    color: 'white'
  },
  buttonText: {
    fontSize: '24px',
    fontWeight: 'bold'
  },
  buttonSubtext: {
    fontSize: '14px',
    opacity: 0.9
  },
  weeklyHours: {
    backgroundColor: 'white',
    margin: '16px',
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#1f2937',
    marginBottom: '8px'
  },
  weekInfo: {
    fontSize: '14px',
    color: '#6b7280',
    marginBottom: '16px'
  },
  weekGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))',
    gap: '12px',
    marginBottom: '16px'
  },
  dayCard: {
    backgroundColor: '#f9fafb',
    borderRadius: '8px',
    padding: '12px',
    textAlign: 'center',
    position: 'relative',
    minHeight: '80px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  dayName: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#1f2937'
  },
  dayDate: {
    fontSize: '11px',
    color: '#6b7280'
  },
  dayHours: {
    fontSize: '18px',
    fontWeight: 'bold',
    marginTop: '4px'
  },
  totalRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px',
    backgroundColor: '#1f2937',
    color: 'white',
    borderRadius: '8px'
  },
  totalNumber: {
    fontSize: '20px',
    fontWeight: 'bold'
  },
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000
  },
  modalTitle: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#1f2937',
    marginBottom: '16px'
  },
  modalDescription: {
    fontSize: '14px',
    color: '#6b7280',
    marginBottom: '20px'
  },
  laborCodeGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '12px',
    marginBottom: '16px'
  },
  laborCodeButton: {
    padding: '12px',
    border: '2px solid #e5e7eb',
    borderRadius: '8px',
    backgroundColor: 'white',
    cursor: 'pointer'
  },
  laborCode: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#1f2937',
    marginBottom: '4px'
  },
  laborName: {
    fontSize: '12px',
    color: '#6b7280'
  },
  lunchButtons: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  lunchButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    padding: '16px',
    borderRadius: '12px',
    border: 'none',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  lunchYesButton: {
    backgroundColor: '#10b981',
    color: 'white'
  },
  lunchNoButton: {
    backgroundColor: '#ef4444',
    color: 'white'
  },
  convertButtons: {
    display: 'flex',
    gap: '12px'
  },
  convertButtonOption: {
    flex: 1,
    padding: '12px',
    border: 'none',
    borderRadius: '8px',
    color: 'white',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  lateShiftButtons: {
    display: 'flex',
    gap: '12px'
  },
  lateButton: {
    flex: 1,
    padding: '12px',
    border: 'none',
    borderRadius: '8px',
    color: 'white',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  openEntryButtons: {
    display: 'flex',
    gap: '12px',
    marginTop: '20px'
  },
  openEntryButton: {
    flex: 1,
    padding: '12px',
    border: 'none',
    borderRadius: '8px',
    color: 'white',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  cancelButton: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#f3f4f6',
    border: 'none',
    borderRadius: '8px',
    color: '#6b7280',
    fontWeight: '600',
    cursor: 'pointer'
  },
  errorModal: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.7)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000
  },
  errorContent: {
    backgroundColor: 'white',
    borderRadius: '16px',
    padding: '32px',
    margin: '20px',
    maxWidth: '90%',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px'
  },
  errorText: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#991b1b'
  },
  errorButton: {
    padding: '12px 32px',
    backgroundColor: '#ef4444',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  loadingOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#1f2937',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '20px',
    zIndex: 3000
  },
  loadingSpinner: {
    animation: 'spin 1s linear infinite'
  },
  loadingText: {
    color: 'white',
    fontSize: '18px',
    fontWeight: '500'
  },
  locationErrorInOverlay: {
    marginTop: '20px',
    backgroundColor: 'rgba(239, 68, 68, 0.2)',
    border: '1px solid rgba(239, 68, 68, 0.4)',
    borderRadius: '8px',
    padding: '16px',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    maxWidth: '90%',
    textAlign: 'center'
  },
  criticalErrorBanner: {
    backgroundColor: '#fef2f2',
    border: '2px solid #fecaca',
    borderRadius: '12px',
    padding: '16px',
    margin: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    boxShadow: '0 4px 12px rgba(239, 68, 68, 0.1)'
  },
  errorBannerContent: {
    display: 'flex',
    gap: '12px',
    alignItems: 'flex-start'
  },
  errorBannerText: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  errorBannerTitle: {
    color: '#991b1b',
    fontSize: '16px',
    fontWeight: '600',
    margin: 0
  },
  errorBannerMessage: {
    color: '#7f1d1d',
    fontSize: '14px',
    margin: 0,
    lineHeight: '1.5'
  },
  retryButton: {
    backgroundColor: '#ef4444',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    padding: '12px 20px',
    fontSize: '16px',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    width: '100%'
  }
};

// CSS animation styles that need to be injected into the document
export const animationStyles = `
  @keyframes slideDown {
    from {
      transform: translateY(-100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

// Helper function to inject animation styles
export const injectAnimationStyles = () => {
  if (typeof document !== 'undefined' && !document.getElementById('clocksystem-styles')) {
    const styleSheet = document.createElement('style');
    styleSheet.id = 'clocksystem-styles';
    styleSheet.textContent = animationStyles;
    document.head.appendChild(styleSheet);
  }
};